__turbopack_context__.v({
  "addButton": "AddProductButton-module__Aied-G__addButton",
  "addButtonWrapper": "AddProductButton-module__Aied-G__addButtonWrapper",
  "closeBtn": "AddProductButton-module__Aied-G__closeBtn",
  "fadeIn": "AddProductButton-module__Aied-G__fadeIn",
  "form": "AddProductButton-module__Aied-G__form",
  "formGroup": "AddProductButton-module__Aied-G__formGroup",
  "formRow": "AddProductButton-module__Aied-G__formRow",
  "modalContent": "AddProductButton-module__Aied-G__modalContent",
  "modalHeader": "AddProductButton-module__Aied-G__modalHeader",
  "modalOverlay": "AddProductButton-module__Aied-G__modalOverlay",
  "slideUp": "AddProductButton-module__Aied-G__slideUp",
  "submitBtn": "AddProductButton-module__Aied-G__submitBtn",
});
